<template>
  <v-footer
    app
    fixed
    clipped-left
    v-bind:class="$vuetify.dark ? 'honey-footer-dark ' : 'honey-footer-light '"
  >
    <v-layout align-center justify-center row>
      <v-btn flat icon small @click.stop="setToggleMenuMinimize">
        <v-icon size="20px">
          {{ minimizeSidebar ? 'menu' : 'menu_open' }}
        </v-icon>
      </v-btn>
      <v-flex xs12 sm2 md2 lg1></v-flex>
      <v-flex xs12 class="hidden-xs-only">
        <v-layout align-center justify-center row>
          <v-breadcrumbs>
            <v-icon slot="divider">chevron_right</v-icon>
            <v-breadcrumbs-item
              v-for="(breadcrumb, i) in breadcrumbList"
              :key="i"
              @click="routeTo(i)"
              class="linked"
            >
              <span
                :style="$vuetify.dark ? 'color: #fafafa' : 'color: #303030'"
                >{{ breadcrumb.name }}</span
              >
            </v-breadcrumbs-item>
          </v-breadcrumbs>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm3 md3 lg2 align-right>
        <!--        <v-layout align-center justify-center row>-->
        <!--          <div v-if="can('FOOTER_TASK')">-->
        <!--            <v-tooltip top>-->
        <!--              <CreateUserTask-->
        <!--                slot="activator"-->
        <!--                @AfterSave="taskAfterSave"-->
        <!--              ></CreateUserTask>-->
        <!--              <span>Create user task</span>-->
        <!--            </v-tooltip>-->
        <!--          </div>-->
        <!--          <div v-if="WSConnected">-->
        <!--            <v-tooltip top>-->
        <!--              <v-btn small icon flat slot="activator">-->
        <!--                <v-icon color="accent">power</v-icon>-->
        <!--              </v-btn>-->
        <!--              <span>Socket Service Connected</span>-->
        <!--            </v-tooltip>-->
        <!--          </div>-->
        <!--          <div v-else>-->
        <!--            <v-tooltip top>-->
        <!--              <v-btn-->
        <!--                small-->
        <!--                icon-->
        <!--                flat-->
        <!--                slot="activator"-->
        <!--                @click.stop="connectSocket"-->
        <!--              >-->
        <!--                <v-icon color="accent">power_off</v-icon>-->
        <!--              </v-btn>-->
        <!--              <span>Socket Service disconnected</span>-->
        <!--            </v-tooltip>-->
        <!--          </div>-->
        <div>
          <v-dialog
            max-width="900"
            :class="{ 'pull-right': $vuetify.breakpoint.mdAndUp }"
          >
            <template slot="activator">
              <v-tooltip top>
                <v-btn flat icon small slot="activator">
                  <v-icon color="accent">info</v-icon>
                </v-btn>
                <span>About</span>
              </v-tooltip>
            </template>
            <v-card style="border-radius: 5px;">
              <v-card-text>
                <h1>Tulip | Mobile App</h1>
                <v-layout row wrap class="mt-2">
                  <v-flex>
                    <h3>Download Application</h3>
                    <br />
                    <img
                      src="/images/tulipQR.png"
                      alt="Tulip_iOS_qr"
                      style="width: 200px;"
                    />
                    <img
                      src="/images/tulipAndroid.png"
                      alt="Tulip_android_qr"
                      style="width: 200px;margin-left: 10px"
                    />
                  </v-flex>
                  <v-flex class="pb-1">
                    <h3>Application Profile</h3>
                    <br />
                    <v-dialog fullscreen v-model="profileDialog" persistent>
                      <template slot="activator">
                        <v-btn slot="activator" class="text-capitalize">
                          Click to preview Profile infomation
                        </v-btn>
                      </template>
                      <v-card>
                        <div class="pt-2">
                          <div style="display: flex; justify-content: flex-end">
                            <div>
                              <v-btn
                                small
                                class="text-capitalize"
                                @click.stop="profileDialog = false"
                              >
                                Close
                              </v-btn>
                            </div>
                          </div>

                          <h3>
                            ** Note: Please hold your phone closer to the screen
                            to Scan QR code to update your profile
                          </h3>
                          <img
                            class="pt-2"
                            :src="qrImageSrc"
                            alt="iOS_Bacardi_Prod_QR"
                            style="width: 600px;"
                          />
                        </div>
                      </v-card>
                    </v-dialog>
                    <!--                      <img-->
                    <!--                        :src="qrImageSrc"-->
                    <!--                        alt="iOS_Bacardi_Prod_QR"-->
                    <!--                        style="width: 200px;"-->
                    <!--                      />-->
                  </v-flex>
                </v-layout>
                <h5>
                  ** Note: Please hold your phone closer to the screen to Scan
                  QR code.
                </h5>
                <v-divider />
                <h1 class="mt-1">About Us</h1>
                <v-layout row wrap>
                  <v-flex xs6>
                    <img
                      src="/images/TulipLogo.png"
                      alt="Tulip"
                      style="width: 100px;padding-top: 10px"
                    />
                    <p>
                      - An Intelligent Automation platform. <br />
                      Developed & maintained by <br />Beez Innovation Labs
                      Private Limited.
                    </p>
                  </v-flex>
                  <v-flex xs6>
                    <img
                      src="/images/BeezLabslogo.png"
                      alt="BeezLabs logo"
                      style="width: 80px;padding-top: 10px"
                    />
                    <p>
                      Version Overview
                      <br />
                      Tulip version: 1.1.1
                    </p>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
        <!--        </v-layout>-->
      </v-flex>
      <v-snackbar
        class="mb-2"
        style="border-radius: 10px"
        v-model="snackbar"
        bottom
        :timeout="0"
      >
        {{ message }}
        <v-btn icon flat @click="snackbar = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-footer>
</template>

<script>
import _ from 'lodash'
import CreateUserTask from '@/components/task-lists/CreateUserTask'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'TheFooter',
  components: { CreateUserTask },
  created() {
    this.renderQrCodes()
  },
  data: () => {
    return {
      profileDialog: false,
      message: '',
      snackbar: false,
      loadInfinitely: true,
      showLoader: true,
      loaderValue: 0,
      breadcrumbList: [],
      qrImageSrc: ''
    }
  },
  computed: {
    ...mapState({
      user: state => state.session.user,
      tulipMaintenance: state => state.admin.tulipMaintenance,
      blockSupport: state => state.admin.blockSupport,
      WSConnected: state => state.socket.WSConnected,
      minimizeSidebar: state => state.honeyUsers.minimizeSidebar
    }),
    ...mapGetters({
      can: 'can'
    })
  },
  mounted() {
    this.updateList()
    this.setSnackBar()
  },
  watch: {
    $route() {
      this.updateList()
    },
    user() {
      this.setSnackBar()
    },
    tulipMaintenance() {
      this.setSnackBar()
    },
    blockSupport() {
      this.setSnackBar()
    }
  },
  methods: {
    renderQrCodes() {
      if (
        window.location.href.startsWith(
          'http://localhost' || 'https://dev.tulip.beezlabs'
        )
      ) {
        this.qrImageSrc = '/images/prod-beezlabs.png'
      } else if (window.location.href.startsWith('https://tulip.beezlabs')) {
        this.qrImageSrc = '/images/prod-beezlabs.png'
      } else if (window.location.href.startsWith('https://tulip.onebacardi')) {
        this.qrImageSrc = '/images/prod-bacardi.png'
      } else if (
        window.location.href.startsWith('https://dev-tulip.onebacardi')
      ) {
        this.qrImageSrc = '/images/dev-bacardi.png'
      }
    },
    setSnackBar() {
      this.snackbar = false
      if (this.user && this.user.roles) {
        if (
          this.user.roles.indexOf('AUTOMATION_ADMIN') > -1 &&
          this.blockSupport === false
        ) {
          this.snackbar = true
          this.message =
            'Hello Admin, Please block the support user login in Tulip Maintenance'
        }
        if (
          this.user.roles.indexOf('SUPPORT') > -1 &&
          this.tulipMaintenance === false
        ) {
          this.snackbar = true
          this.message =
            'Hello Super User, Please set the Tulip system in maintenance'
        }
      }
    },
    setToggleMenuMinimize() {
      this.$store.dispatch('toggleMenuMinimize')
    },
    routeTo(route) {
      if (this.breadcrumbList[route].link) {
        this.$router.push(this.breadcrumbList[route].link).catch()
      }
    },
    updateList() {
      this.breadcrumbList = this.$route.meta.breadcrumb.map(crumb => {
        if (_.isFunction(crumb.link)) {
          let link = crumb.link(this.$route)
          return {
            name: crumb.name,
            link: link
          }
        } else {
          return crumb
        }
      })
    },
    taskAfterSave() {
      this.$store.dispatch('fetchOwnTasks')
    },
    connectSocket() {
      // this.$store.dispatch('subscribeSockets')
    }
  }
}
</script>

<style scoped>
.honey-footer-dark {
  /* z-index: 999; */
  background-color: #303030 !important;
  border-color: #fafafa !important;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.12);
}

.honey-footer-light {
  /* z-index: 999; */
  border-color: #303030 !important;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.2);
  background-color: #fafafa !important;
}

.linked {
  cursor: pointer;
  font-size: 0.9em;
  font-weight: bold;
}
</style>
